import { COMPONENT_VALUE_TYPES as types, BUTTON_SIZE, FIELD_TYPE, REGIONS } from 'shared/constants';

const propsSchema = [
  {
    key: 'eventInfo',
    label: 'Event Info',
    type: types.OBJECT,
    children: [
      {
        key: 'eventName',
        label: 'Event Name',
        type: types.TEXT
      },
      {
        key: 'eventCode',
        label: 'Event Code (Initials)',
        type: types.TEXT
      },
      {
        key: 'eventNote',
        label: 'Note',
        type: types.TEXT
      },
    ]
  },
  {
    key: 'formLocale',
    label: 'Form Locale',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'formField',
    label: 'Form Field',
    type: types.ARRAY,
    children: [
      {
        key: 'firstField',
        label: 'First Field',
        type: types.TEXT,
      },
      {
        key: 'firstFieldRequired',
        label: 'First Field Required',
        type: types.BOOLEAN
      },
      {
        key: 'firstFieldType',
        label: 'First Field Type',
        type: types.ENUM,
        options: FIELD_TYPE
      },
      {
        key: 'secondField',
        label: 'Second Field',
        type: types.TEXT,
      },
      {
        key: 'secondFieldRequired',
        label: 'Second Field Required',
        type: types.BOOLEAN
      },
      {
        key: 'secondFieldType',
        label: 'Second Field Type',
        type: types.ENUM,
        options: FIELD_TYPE
      },
    ]
  },
  {
    key: 'submitButtonText',
    label: 'Button Text',
    type: types.TEXT
  },
  {
    key: 'submitMessage',
    label: 'Submit Message',
    type: types.TEXT
  },
  {
    key: 'redirectText',
    label: 'Redirect Button Text',
    type: types.TEXT
  },
  {
    key: 'redirectUrl',
    label: 'Redirect Url',
    type: types.TEXT
  },
  {
    key: 'buttonSize',
    label: 'Button Size',
    type: types.ENUM,
    options: BUTTON_SIZE
  }
];

const defaultProps = {
  eventInfo: {
    eventName: 'FF 91',
    eventCode: 'TR',
    eventNote: ''
  },
  formLocale: 'US',
  formField: [
    {
      firstField: 'First Name*',
      firstFieldRequired: true,
      firstFieldType: 'First Name',
      secondField: 'Last Name*',
      secondFieldRequired: true,
      secondFieldType: 'Last Name'
    },
    {
      firstField: 'Email*',
      firstFieldRequired: true,
      firstFieldType: 'Email',
      secondField: '',
      secondFieldRequired: false,
      secondFieldType: ''
    }
  ],
  submitButtonText: 'Submit',
  submitMessage: 'Thank you for submission!',
  redirectText: 'Explore FF 91',
  redirectUrl: '/us/ff91',
  buttonSize: 'LARGE',
};

export default {
  title: 'Event Form',
  id: 'EventForm',
  widgetImage: `/widgetImages/Form+submission.png`,
  basic: true,
  propsSchema,
  defaultProps
};
